import React from 'react'
import { StyledTitle } from './style'

const Title = ({ center, children }) => (
  <StyledTitle center={center}>{children}</StyledTitle>
)

export default Title
